<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Зорчилтын нэгдсэн сан"> </main-header>
    <div class="content-body">
      <div class="container pd-0-f">
        <div class="card">
          <div
            class="card-header pd-y-20 d-flex align-items-center justify-content-between"
          >
            <h6 class="mg-b-0 text-muted">Т/X улсын №</h6>
            <div class="mg-l-auto text-muted">
              Үр дүн : {{ routeSrch.count }}
            </div>
          </div>
          <!-- card-header -->
          <div class="card-body pos-relative pd-0 ht-70v">
            <div class="d-block d-sm-none pd-10">
              <a
                @click="filterMdl = true"
                class="btn btn-block btn-primary btn-xs"
                >Хайх</a
              >

              <div v-if="atutInfoRdy" ref="printArea" class="mg-y-20">
                <div
                  class="pd-r-10"
                  v-if="xypInfo != undefined && xypInfo != null"
                >
                  <div class="">
                    <div class="card ht-md-100p">
                      <div class="card-header d-flex justify-content-between">
                        <h6 class="lh-5 mg-b-0">Тээврийн хэрэгсэл</h6>
                      </div>
                      <div class="card-body pd-0 tx-13">
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Улсын дугаар</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ routeSrch.plateNo }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Арлын дугаар</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.cabinNumber }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Гэрчилгээний дугаар</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.certificateNumber }}
                          </p>
                        </div>

                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Үйлдвэрлэсэн</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.buildYear }}, {{ xypInfo.countryName }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Моторын багтаамж</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.capacity }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Өнгө</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.colorName }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Марк, модел</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.markName }}, {{ xypInfo.modelName }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Түлш</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.fueltype }}
                          </p>
                        </div>
                      </div>
                      <!-- card-body -->
                    </div>
                    <!-- card -->
                  </div>

                  <div class="mg-t-20">
                    <div class="card ht-md-100p">
                      <div class="card-header d-flex justify-content-between">
                        <h6 class="lh-5 mg-b-0">Татвар</h6>
                      </div>
                      <div v-if="taxesFailed" class="card-body tx-13">
                        <div
                          class="alert alert-warning alert-dismissible fade show mg-b-0"
                          role="alert"
                        >
                          <strong>Мэдэгдэл</strong> Татварын мэдээлэл олдсонгүй
                        </div>
                      </div>
                      <div class="card-body pd-0 tx-13" v-else>
                        <div
                          class="mg-sm-l-15"
                          v-for="(t, i) in taxes"
                          :key="i"
                        >
                          <p class="tx-medium mg-b-0">{{ t.taxTypeName }}</p>
                          <div class="d-flex">
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ t.payAmount }}
                            </p>
                            <div class="mg-l-auto tx-12 pd-r-20">
                              Төлсөн эсэх : {{ t.isPay == 1 ? "Тийм" : "Үгүй" }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- card-body -->
                    </div>
                    <!-- card -->
                  </div>

                  <div class="mg-t-20">
                    <div class="card ht-md-100p">
                      <div class="card-header d-flex justify-content-between">
                        <h6 class="lh-5 mg-b-0">Өмчлөгчийн мэдээлэл</h6>
                      </div>
                      <div class="card-body pd-0 tx-13">
                        <!-- <div class="mg-sm-l-15" v-if="!xypInfo.hasOwner"> -->
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Овог</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.holderLastname }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Нэр</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.holderFirstname }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Регистр</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.holderRegnum }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Утас</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.holderHandphone }},
                            {{ xypInfo.holderWorkphone }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Хаяг</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.holderAddressBuilded }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Төлөв</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.holderType }}
                          </p>
                        </div>
                      </div>
                      <!-- card-body -->
                    </div>
                    <!-- card -->
                  </div>
                  <div class="mg-t-20" v-if="xypInfo.hasOwner">
                    <div class="card ht-md-100p bg-light">
                      <div
                        class="card-header d-flex justify-content-between border-primary"
                      >
                        <h6 class="lh-5 mg-b-0">Эзэмшигчийн мэдээлэл</h6>
                      </div>
                      <div class="card-body pd-0 tx-13">
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Овог</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.ownerLastName }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Нэр</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.ownerFirstName }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Регистр</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.ownerRegnum }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Утас</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.ownerCellPhone }},
                            {{ xypInfo.ownerWorkPhone }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Хаяг</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.ownerAddressBuilded }}
                          </p>
                        </div>
                        <div class="mg-sm-l-15">
                          <p class="tx-medium mg-b-0">Төлөв</p>
                          <p class="tx-12 mg-b-0 tx-color-03">
                            {{ xypInfo.ownerTypeName }}
                          </p>
                        </div>
                      </div>
                      <!-- card-body -->
                    </div>
                    <!-- card -->
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="pd-10 wd-30p d-none d-sm-block">
                <div class="">
                  <form class="pd-10">
                    <div class="form-group">
                      <label>Бүртгэлтэй төхөөрөмжүүд</label>
                      <Select
                        filterable
                        clearable
                        multiple
                        collapse-tags
                        v-model="cameraIds"
                      >
                        <Option
                          :value="c.id"
                          v-for="c in cameras"
                          :key="`key_${c.id}`"
                          :label="c.name"
                        >
                          {{ c.name }}
                        </Option>
                      </Select>
                      <!-- <DatePicker
                            v-model="routeSrch.startDate"
                            placeholder="Огноо сонгоно уу"
                            type="datetime"
                            style="width: 100%"
                            :format="'yyyy-MM-dd HH:mm:ss'"
                            :value-format="'yyyy-MM-dd HH:mm:ss'"
                        ></DatePicker> -->
                    </div>

                    <div class="form-group">
                      <label>Эхлэх огноо</label>
                      <DatePicker
                        v-model="routeSrch.startDate"
                        placeholder="Огноо сонгоно уу"
                        type="datetime"
                        style="width: 100%"
                        :format="'yyyy-MM-dd HH:mm:ss'"
                        :value-format="'yyyy-MM-dd HH:mm:ss'"
                      ></DatePicker>
                    </div>

                    <div class="form-group">
                      <label>Дуусах огноо</label>
                      <DatePicker
                        v-model="routeSrch.endDate"
                        placeholder="Огноо сонгоно уу"
                        type="datetime"
                        style="width: 100%"
                        :format="'yyyy-MM-dd HH:mm:ss'"
                        :value-format="'yyyy-MM-dd HH:mm:ss'"
                      ></DatePicker>
                    </div>
                    <div class="form-group">
                      <label>Улсын дугаар</label>
                      <input
                        v-model="routeSrch.plateNo"
                        class="form-control form-control-xs"
                      />
                    </div>
                    <div class="form-group">
                      <a
                        @click="searchRoute"
                        role="button"
                        class="btn btn-primary btn-block"
                        >Хайх</a
                      >
                    </div>
                  </form>
                </div>

                <div v-if="atutInfoRdy" ref="printArea">
                  <div
                    class="pd-r-10"
                    v-if="xypInfo != undefined && xypInfo != null"
                  >
                    <div class="">
                      <div class="card ht-md-100p">
                        <div class="card-header d-flex justify-content-between">
                          <h6 class="lh-5 mg-b-0">Тээврийн хэрэгсэл</h6>
                        </div>
                        <div class="card-body pd-0 tx-13">
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Улсын дугаар</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ routeSrch.plateNo }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Арлын дугаар</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.cabinNumber }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Гэрчилгээний дугаар</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.certificateNumber }}
                            </p>
                          </div>

                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Үйлдвэрлэсэн</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.buildYear }}, {{ xypInfo.countryName }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Моторын багтаамж</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.capacity }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Өнгө</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.colorName }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Марк, модел</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.markName }}, {{ xypInfo.modelName }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Түлш</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.fueltype }}
                            </p>
                          </div>
                        </div>
                        <!-- card-body -->
                      </div>
                      <!-- card -->
                    </div>

                    <div class="mg-t-20">
                      <div class="card ht-md-100p">
                        <div class="card-header d-flex justify-content-between">
                          <h6 class="lh-5 mg-b-0">Татвар</h6>
                        </div>
                        <div v-if="taxesFailed" class="card-body tx-13">
                          <div
                            class="alert alert-warning alert-dismissible fade show mg-b-0"
                            role="alert"
                          >
                            <strong>Мэдэгдэл</strong> Татварын мэдээлэл
                            олдсонгүй
                          </div>
                        </div>
                        <div class="card-body pd-0 tx-13" v-else>
                          <div
                            class="mg-sm-l-15"
                            v-for="(t, i) in taxes"
                            :key="i"
                          >
                            <p class="tx-medium mg-b-0">{{ t.taxTypeName }}</p>
                            <div class="d-flex">
                              <p class="tx-12 mg-b-0 tx-color-03">
                                {{ t.payAmount }}
                              </p>
                              <div class="mg-l-auto tx-12 pd-r-20">
                                Төлсөн эсэх :
                                {{ t.isPay == 1 ? "Тийм" : "Үгүй" }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- card-body -->
                      </div>
                      <!-- card -->
                    </div>

                    <div class="mg-t-20">
                      <div class="card ht-md-100p">
                        <div class="card-header d-flex justify-content-between">
                          <h6 class="lh-5 mg-b-0">Өмчлөгчийн мэдээлэл</h6>
                        </div>
                        <div class="card-body pd-0 tx-13">
                          <!-- <div class="mg-sm-l-15" v-if="!xypInfo.hasOwner"> -->
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Овог</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.holderLastname }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Нэр</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.holderFirstname }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Регистр</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.holderRegnum }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Утас</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.holderHandphone }},
                              {{ xypInfo.holderWorkphone }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Хаяг</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.holderAddressBuilded }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Төлөв</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.holderType }}
                            </p>
                          </div>
                        </div>
                        <!-- card-body -->
                      </div>
                      <!-- card -->
                    </div>
                    <div class="mg-t-20" v-if="xypInfo.hasOwner">
                      <div class="card ht-md-100p bg-light">
                        <div
                          class="card-header d-flex justify-content-between border-primary"
                        >
                          <h6 class="lh-5 mg-b-0">Эзэмшигчийн мэдээлэл</h6>
                        </div>
                        <div class="card-body pd-0 tx-13">
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Овог</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.ownerLastName }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Нэр</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.ownerFirstName }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Регистр</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.ownerRegnum }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Утас</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.ownerCellPhone }},
                              {{ xypInfo.ownerWorkPhone }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Хаяг</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.ownerAddressBuilded }}
                            </p>
                          </div>
                          <div class="mg-sm-l-15">
                            <p class="tx-medium mg-b-0">Төлөв</p>
                            <p class="tx-12 mg-b-0 tx-color-03">
                              {{ xypInfo.ownerTypeName }}
                            </p>
                          </div>
                        </div>
                        <!-- card-body -->
                      </div>
                      <!-- card -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="bd-l wd-100p">
                <nav data-v-232b54ff="" aria-label="Page navigation example ">
                  <ul
                    data-v-232b54ff=""
                    class="pagination mg-b-0 pagination-filled justify-content-center"
                  >
                    <li data-v-232b54ff="" class="page-item">
                      <a
                        @click="
                page.cur = 0;
                searchRoute();
              "
                        
                        class="page-link page-link-icon"
                        ><i class="el-icon-d-arrow-left"></i>
                      
                      </a>
                    </li>
                    <li data-v-232b54ff="" class="page-item">
                      <a
                        @click="
                page.cur = page.cur > 0 ? page.cur - 1 : 0;
                searchRoute();
              "
                        class="page-link page-link-icon"
                        >
                        <i class="el-icon-arrow-left"></i>
                        </a>
                    </li>
                    <li data-v-232b54ff="" class="page-item">
                      <!-- <select data-v-232b54ff="" class="form-control"
                        >

                        <option data-v-232b54ff="" value="0">
                          1 </option
                        >
                        
                        </select
                      > -->
                      <select @change="searchRoute()" v-model="page.cur" class="form-control">
                <!-- <option :value="0">1</option> -->
                <option
                  :value="i"
                  :key="i"
                  
                  v-for="(l, i) in Math.ceil(page.count / page.size)"
                >
                  {{ i + 1 }}
                </option>
              </select>

                    </li>
                    <li  class="page-item">
                      <a
                        @click="
                page.cur =
                  page.cur + 1 == Math.ceil(page.count / page.size)
                    ? 0
                    : page.cur + 1;
                searchRoute();
              "
                        
                        class="page-link page-link-icon"
                        ><i
                          
                          class="el-icon-arrow-right"
                        ></i
                      ></a>
                    </li>
                    <li  class="page-item">
                      <a
                        @click="
                page.cur = Math.ceil(page.count / page.size) - 1;
                searchRoute();
              "
                        
                        class="page-link page-link-icon"
                        ><i
                          
                          class="el-icon-d-arrow-right"
                        ></i
                      ></a>
                    </li>
                  </ul>
                </nav>

                <table
                  class="table table-bordered table-striped table-responsive table-sm"
                >
                  <thead class="thead-primary">
                    <tr>
                      <th scope="col">Д/д</th>
                      <th scope="col">Огноо</th>
                      <th scope="col">Эх үүсвэр</th>
                      <th scope="col">Дугаар</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      @click="fillRowInfo(r.id)"
                      v-for="(r, i) in routeSrch.list"
                      :key="i"
                      :class="`${r.hasDetail ? 'tx-primary' : ''}`"
                      :role="`${r.hasDetail ? 'button' : ''}`"
                    >
                      <th scope="row">{{ (page.cur*page.size)+i + 1 }}</th>
                      <td>
                        {{ r.date | moment("yyyy.MM.DD HH:mm:ss") }}
                        <sup>{{ r.date | moment("dd") }}</sup>
                      </td>
                      <td>{{ r.cameraName }}</td>
                      <td>{{ r.plate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Дэлгэрэнгүй"
      v-model="routeSrchDtl.mdl"
      hide-footer
      scrollable
      centered
      size="lg"
    >
      <!-- {{routeSrchDtl.obj}} -->
      <div class="card-body pd-0 tx-13">
        <div class="mg-sm-l-15">
          <p class="tx-medium mg-b-0">Улсын дугаар</p>
          <p class="tx-12 mg-b-0 tx-color-03">{{ routeSrchDtl.obj.plate }}</p>
        </div>
        <div class="mg-sm-l-15">
          <p class="tx-medium mg-b-0">Эх үүсвэр</p>
          <p class="tx-12 mg-b-0 tx-color-03">
            {{ routeSrchDtl.obj.cameraName }}
          </p>
        </div>
        <div class="mg-sm-l-15">
          <p class="tx-medium mg-b-0">Огноо</p>
          <p class="tx-12 mg-b-0 tx-color-03">{{ routeSrchDtl.obj.date }}</p>
        </div>
        <div class="mg-sm-l-15 media pd-t-10">
          <!-- <p class="tx-medium mg-b-0">Зураг</p> -->
          <img
            :src="`${routeSrchDtl.obj.fullPhoto}?w=1200`"
            style="max-width: 100%"
            class="rounded"
          />
        </div>
      </div>
      <!-- card-body -->
    </b-modal>

    <b-modal title="Хайх" v-model="filterMdl" hide-footer scrollable centered>
      <form class="pd-10">
        <div class="form-group">
          <label>Эхлэх огноо</label>
          <DatePicker
            v-model="routeSrch.startDate"
            placeholder="Огноо сонгоно уу"
            type="datetime"
            style="width: 100%"
            :format="'yyyy-MM-dd HH:mm:ss'"
            :value-format="'yyyy-MM-dd HH:mm:ss'"
          ></DatePicker>
        </div>

        <div class="form-group">
          <label>Дуусах огноо</label>
          <DatePicker
            v-model="routeSrch.endDate"
            placeholder="Огноо сонгоно уу"
            type="datetime"
            style="width: 100%"
            :format="'yyyy-MM-dd HH:mm:ss'"
            :value-format="'yyyy-MM-dd HH:mm:ss'"
          ></DatePicker>
        </div>
        <div class="form-group">
          <label>Улсын дугаар</label>
          <input
            v-model="routeSrch.plateNo"
            class="form-control form-control-xs"
          />
        </div>
        <div class="form-group">
          <a
            @click="
              filterMdl = false;
              searchRoute();
            "
            role="button"
            class="btn btn-primary btn-block"
            >Хайх</a
          >
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Switch, Select, Option } from "element-ui";

const moment = require("moment");
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    Switch,
    DatePicker,
    Select,
    Option,

    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
page: {
        count: 0,
        size: 50,
        cur: 0,
      },

      props: { multiple: true },
      cameras: [
        // { id: 1, name: "bagsh" },
        // { id: 2, name: "32" },
      ],
      cameraIds: null,
      filterMdl: false,
      atutInfoRdy: false,
      taxesFailed: false,
      taxes: [],
      xypInfo: {},
      routeSrchDtl: {
        mdl: false,
        obj: {},
      },
      routeSrch: {
        plateNo: null,
        startDate: null,
        endDate: null,
        list: [],
        count: null,
      },
    };
  },
  mounted() {
    this.routeSrch.startDate = moment()
      .startOf("day")
      .format("yyyy-MM-DD HH:mm:ss");
    this.routeSrch.endDate = moment().format("yyyy-MM-DD HH:mm:ss");

    request({
      api: { method: "GET", url: "TrafficData/GetDevices" },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        this.cameras = res.data.list;
      }
    });
  },
  methods: {
    searchRoute() {
      this.routeSrch.list = [];
      this.routeSrch.count = null;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/GetVehicleRouteData" },
        data: {
          plateNo: this.routeSrch.plateNo,
          startDate: this.routeSrch.startDate,
          endDate: this.routeSrch.endDate,
          cameraIds: this.cameraIds,
          page: this.page.cur,
          size: this.page.size,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('res', res);
        if (res != false) {
          console.log("res list", res);
          this.page.count = res.data.allCount;
          this.routeSrch.list = res.data.list;
          this.routeSrch.count = res.data.allCount;
          this.fillVehicleInfo(this.routeSrch.plateNo);
        }
      });
    },
    fillVehicleInfo(plate) {
      this.atutInfoRdy = false;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/GetVehicleInfo" },
        params: {
          plateNo: plate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('res', res);
        if (res != false) {
          console.log("res inf", res);
          this.xypInfo = res.data.vehicleInfo;
          this.atutInfoRdy = true;
        }
      });
    },
    fillRowInfo(id) {
      //this.atutInfoRdy= false;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/GetVehicleRouteDetail" },
        params: {
          id: id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('res', res);
        if (res != false) {
          console.log("res det", res);
          this.routeSrchDtl.obj = res.data.detail;
          this.routeSrchDtl.mdl = true;
          // this.xypInfo= res.data.vehicleInfo;
          // this.atutInfoRdy= true;
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
};
</script>
